<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
        isDelete: true
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>

import GridView from "../../../components/common/GridView";
export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('Setupformsetup.formsetuplisting'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('Setupformsetup.formcode'), value: "formcode", width: "200px" },
        { text: this.$t('Setupformsetup.formsetupname'), value: "formname", width: "200px" },
        { text: this.$t('columns.disable'), value: "disabletext", width: "200px" },
        { text: this.$t('columns.type'), value: "typetext", width: "200px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
       search: this.$route.params.search,
    };
  },

  methods: {
    getReviewFormHandler() {
      const vm = this;
      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/reviewform/all"})
        .then(function (res) {
            vm.dataItems = res.data.rec.map(item => {
              return {
                ...item,
                disabletext: item.disable === 1 ? 'Yes' : 'No',
                typetext: item.formtype === 'R' ? 'Rank' : 'Grid'
              };
            });
          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "formsetupedit", params: { id: item.id, search: item.search  } });
    },

    deleteItemHandler(item) {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
      }

      if (confirm(this.$t('pmformsetup.deletereviewform', { code: item.formcode }))) {
        this.$store.dispatch('delete', {url: "/reviewform/" + item.id})
          .then(function () {
            vm.getReviewFormHandler();
          })
          .catch(function (err) {
            vm.errMsg = err;
          });
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "formsetupnew" });
    },
  },

  mounted() {
    this.getReviewFormHandler();
  },
};
</script>